import React, { FC } from 'react';
import Dialog, { UseDialogReturnType } from 'components/organization/dialog/dialog';

export interface ConfirmDeletePresetDialogProps {
  dialog: UseDialogReturnType;
  presetName: string;
  onConfirm: () => void;
}

export const ConfirmDeletePresetDialog: FC<ConfirmDeletePresetDialogProps> = ({ dialog, presetName, onConfirm }) => {
  const handleConfirm = () => {
    onConfirm();
    dialog.closeDialog();
  };

  return (
    <Dialog ref={dialog.ref} closeDialog={dialog.closeDialog} data-cy="confirm-delete-preset-dialog">
      <div className="dialog-header">
        <h4>Confirm Delete</h4>
        <button className="icon-button" onClick={dialog.closeDialog} data-cy="confirm-delete-preset-dialog-close">
          <span className="material-icons">close</span>
        </button>
      </div>
      <div className="dialog-body">
        <p className="mb-0">
          Are you sure you want to delete the saved filter preset <strong>{presetName}</strong>? This action cannot be
          undone.
        </p>
      </div>
      <div className="dialog-footer d-flex justify-content-end mt-3" style={{ gap: '12px' }}>
        <button className="btn-outline" onClick={dialog.closeDialog} data-cy="confirm-delete-preset-dialog-cancel">
          Cancel
        </button>
        <button className="btn-danger" onClick={handleConfirm} data-cy="confirm-delete-preset-dialog-confirm">
          Delete
        </button>
      </div>
    </Dialog>
  );
};
